import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LaravelResourceResponse } from '../../../../../../_base-shared/contracts/laravel-response.interface';
import { MainBaseApiService } from '../../../_shared/services/main-base-api.service';
import { Notary } from '../../../../../../_base-shared/models/Entity/Notary';

@Injectable({
  providedIn: 'root',
})
export class NotariesService extends MainBaseApiService {

  index(data): Observable<LaravelResourceResponse<any>> {
    return this.http.get<LaravelResourceResponse>(this.apiUrl + '/notaries', {params: data})
        .pipe(catchError(response => this.handleError(response)));
  }

  show(id: number): Observable<LaravelResourceResponse<Notary>> {
    return this.http.get<LaravelResourceResponse<Notary>>(this.apiUrl + '/notaries/' + id)
        .pipe(catchError(response => this.handleError(response)));
  }

  store(data): Observable<LaravelResourceResponse<Notary>> {
    return this.http.post<LaravelResourceResponse<Notary>>(this.apiUrl + '/notaries', data)
        .pipe(catchError(response => this.handleError(response)));
  }

  saveNotary(caseId, data): Observable<LaravelResourceResponse<Notary>> {
    return this.http.post<LaravelResourceResponse<Notary>>(this.apiUrl + `/cases/${caseId}/save-notary`, data)
        .pipe(catchError(response => this.handleError(response)));
  }

  update(id: number, data): Observable<LaravelResourceResponse<Notary>> {
    return this.http.put<LaravelResourceResponse<Notary>>(this.apiUrl + '/notaries/' + id, data)
        .pipe(catchError(response => this.handleError(response)));
  }

  delete(id: number): Observable<LaravelResourceResponse<Notary>> {
    return this.http.delete<LaravelResourceResponse<Notary>>(this.apiUrl + '/notaries/' + id)
        .pipe(catchError(response => this.handleError(response)));
  }
}
